import $ from 'jquery';
import Utils from '../../utils';
export default class EwalletConfirmModal {
    static init() {
        const $button = $('.js__e-wallet-confirm-modal-button');
        if (!$button.length) {
            return;
        }
        $button.each((index, element) => {
            const $element = $(element);
            $element.on('click', e => {
                const $button = $(e.currentTarget);
                if (!Utils.isMobile()) {
                    e.preventDefault();
                    const $modal = $('.js__e-wallet-confirm-modal');
                    $modal.modal();
                    const $submitButton = $modal.find('.js__submit-btn');
                    $submitButton.on('click', () => {
                        window.open($button.attr('href'), '_blank');
                        $modal.modal('hide');
                    });
                    $modal.on('hidden.bs.modal', () => {
                        $submitButton.off('click');
                    });
                }
            });
        });
    }
}
